<template>
    <div class="m-cnt">
        <mt-header title="商品详情">
            <router-link to="/mkt/group" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header>
        <div class="goods-box">
            <img src="https://img.huashitong.net/mkt/goods-vip.png" alt="" v-if="goodsType==1">
            <img src="https://img.huashitong.net/mkt/goods-svip.png" alt="" v-else-if="goodsType==2">
            <img :src="goodsData.goodsImageUrl" alt="" v-else>
            <div class="goods-info">
                <div class="goods-name">{{goodsData.goodsName}}</div>
                <div class="goods-brief">{{goodsData.description?goodsData.description:goodsData.goodsName}}</div>
            </div>
        </div>
        <div class="goods-type">
            <div @click="toInitiate(1)"><span class="price"><em>￥</em>{{goodsData.threeGroupPrice}}</span><span>3人团专享</span></div>
            <div @click="toInitiate(2)"><span class="price"><em>￥</em>{{goodsData.fiveGroupPrice}}</span><span>5人团专享</span>
            </div>
        </div>
        <div class="goods-other">
            <div class="other-title">这些人刚刚发起拼团，可直接参与拼团</div>
            <div class="other-list">
                <div class="other-item" v-for="item in goodsData.userGroupGoodsInfoVOS" :key="item.groupId">
                    <div class="other-avatar"
                        :style="`background-image:url(${item.userImage?item.userImage:'https://img.huashitong.net/xcx/head-default.png'});`">
                    </div>
                    <div class="other-name">{{item.nickname}}</div>
                    <div class="other-btn" @click="toGroup(item.groupId)">去拼团</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mkt from "@/api/mkt.js";
    import Cookies from 'js-cookie';
    import { Toast, Indicator } from "mint-ui";
    export default {
        name: "goods",
        data() {
            return {
                goodsId: this.$route.params.goodsId,
                goodsType: this.$route.query.g_type, //1VIP 2SVIP 3课程
                minute: '',
                second: '',
                seconds: 1800,
                goodsData: {}
            }
        },
        mounted() {
            Indicator.open("加载中")
            Mkt.getGoodsInfo(this.goodsId, this.goodsType).then(res => {
                if (res.code == 200) {
                    Indicator.close()
                    this.goodsData = res.results
                }
            })
        },
        methods: {
            // 天 时 分 秒 格式化函数
            countDown() {
                // let d = parseInt(this.seconds / (24 * 60 * 60))
                // d = d < 10 ? "0" + d : d
                // let h = parseInt(this.seconds / (60 * 60) % 24)
                // h = h < 10 ? "0" + h : h
                let m = parseInt(this.seconds / 60 % 60)
                this.minute = m < 10 ? "0" + m : m
                let s = parseInt(this.seconds % 60)
                this.second = s < 10 ? "0" + s : s

                // this.minute = m
                // this.second = s
            },
            startTimer() {
                setInterval(() => {
                    this.seconds -= 1
                    this.countDown()
                }, 1000)
            },
            toGroup(id) {
                this.$router.push({
                    path: `/mkt/group/${id}`
                })
            },
            // 发起拼团
            toInitiate(type) {
                if (!Cookies.get("token")) {
                    this.$loginModal();
                    return;
                }
                window.location.href =
                    `https://www.ssydt.com/pay/confirm/${this.goodsId}?g_type=${this.goodsType==3?'03':'01'}&isGroup=true&groupType=${type}&redirect_uri=https://h5.ssydt.com/mkt/group`
            }
        }
    }
</script>


<style lang="less" scoped>
    @activeColor: #2983FE;

    .m-cnt {
        height: 320px;
        background: linear-gradient(180deg, #2983FE 0%, #A9A2FF 100%);
    }

    .mint-header {
        height: 72px;
        font-size: 34px;
        font-weight: bold;
        padding-left: 32px;
        padding-right: 32px;
        background-color: transparent;

        /deep/.mintui-back {
            font-size: 32px;
        }
    }

    .goods-box {
        display: flex;
        justify-content: flex-start;
        margin-left: 30px;
        margin-right: 30px;
        padding: 40px 32px;
        margin-top: 32px;
        background-color: #fff;
        box-shadow: 0 6px 6px 2px rgba(236, 236, 236, 0.8);
        border-radius: 16px;

        img {
            width: 160px;
            height: 160px;
            border-radius: 16px;
        }
    }

    .goods-info {
        margin-left: 32px;
    }

    .goods-name {
        font-size: 36px;
        font-weight: bold;
    }

    .goods-brief {
        margin-top: 10px;
        font-size: 28px;
        color: #999;
    }

    .goods-price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: @activeColor;
        font-size: 32px;
        font-weight: bold;

        span {
            cursor: pointer;
            font-size: 26px;
            font-weight: normal;
            display: inline-block;
            padding: 5px 15px;
            color: #fff;
            border-radius: 6px;
            background-color: @activeColor;
        }
    }

    .goods-type {
        display: flex;
        justify-content: center;
        margin-top: 72px;

        div {
            cursor: pointer;
            width: 280px;
            color: #fff;
            font-size: 32px;
            margin-left: 23px;
            margin-right: 23px;
            padding-top: 16px;
            padding-bottom: 16px;
            background-color: @activeColor;
            border: 2px solid @activeColor;
            border-radius: 16px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            &:first-of-type {
                color: @activeColor;
                border-color: @activeColor;
                background-color: #ECF4FF;
            }
        }

        .price {
            font-size: 44px;
            font-weight: bold;
        }

        em {
            font-size: 24px;
            vertical-align: middle;
            margin-right: 3px;
        }
    }

    .goods-other {
        margin-top: 64px;
    }

    .other-title {
        line-height: 76px;
        background-color: #FFFADE;
        font-size: 32px;
        font-weight: bold;
        padding-left: 32px;
    }

    .other-list {
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: 32px;
    }

    .other-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        margin-top: 32px;
    }

    .other-avatar {
        width: 72px;
        height: 72px;
        background-size: contain;
        background-repeat: no-repeat;
        border-radius: 50%;
    }

    .other-name {
        margin-left: 24px;
        font-size: 28px;
        font-weight: bold;
    }

    .other-btn {
        cursor: pointer;
        color: #fff;
        font-size: 24px;
        text-align: center;
        width: 120px;
        line-height: 48px;
        background-color: @activeColor;
        border-radius: 24px;
        position: absolute;
        right: 0;
    }

    // .goods-status {
    //     font-size: 30px;
    //     text-align: center;
    //     margin-top: 40px;

    //     .state {
    //         font-weight: bold;
    //         padding-bottom: 20px;
    //     }

    //     em {
    //         font-size: 32px;
    //         color: #00a9ff;
    //         font-weight: bold;
    //     }

    //     span {
    //         color: #fff;
    //         padding: 5px;
    //         margin-left: 5px;
    //         margin-right: 5px;
    //         background-color: @activeColor;
    //         border-radius: 4px;
    //     }
    // }

    // .member-list {
    //     margin-top: 30px;
    //     display: flex;
    //     justify-content: center;
    // }

    // .member-item {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     padding: 0 20px;

    //     img {
    //         width: 100px;
    //         height: 100px;
    //         border-radius: 50%;
    //     }

    //     span {
    //         margin-top: 20px;
    //         font-size: 24px;
    //     }
    // }

    // .member-btn {
    //     width: 240px;
    //     line-height: 60px;
    //     margin-top: 20px;
    //     margin-left: auto;
    //     margin-right: auto;
    //     color: #fff;
    //     font-size: 32px;
    //     text-align: center;
    //     background-color: @activeColor;
    //     border-radius: 12px;
    // }
</style>